var _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88994 8.83738C1.59219 8.31877 1.59219 7.68132 1.88994 7.16272C3.4566 4.43399 5.96248 2.66667 8.78649 2.66667C11.6105 2.66667 14.1163 4.43396 15.683 7.16266C15.9808 7.68126 15.9808 8.31871 15.683 8.83732C14.1164 11.5661 11.6105 13.3334 8.78646 13.3334C5.96247 13.3334 3.45661 11.5661 1.88994 8.83738Z",
    stroke: "#0675FC",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.7865,
    cy: 8,
    rx: 2,
    ry: 2,
    stroke: "#0675FC",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAi);
export default __webpack_public_path__ + "static/media/viewAI.dcaa09fd034ede7384ff4ec310ec8168.svg";
export { ForwardRef as ReactComponent };